import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

import { setBasePath } from "@shoelace-style/shoelace";
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
setBasePath("/assets/shoelace");

if (environment.production) {
  enableProdMode();
  console.log = () => {};
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));